var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zmzh-block"},_vm._l((_vm.data.horizontal),function(d,i){return _c(_vm.componentName(i),{key:'h' + i,tag:"component",staticClass:"hori-list",attrs:{"chip":_vm.chip,"horizontal-type":2,"title":d.title,"columns":i !== 1 ? 4 : 3,"list":d.list}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a30d1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageComponents/gd_ha10/zmzh.vue
// module id = null
// module chunks = 